import { render, staticRenderFns } from "./VariablePrdPriceModal.vue?vue&type=template&id=979e410e&"
import script from "./VariablePrdPriceModal.vue?vue&type=script&lang=js&"
export * from "./VariablePrdPriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports